import React, { useState } from 'react';
import { Card } from 'antd';
import { FirmwareReportGroup } from '@services/types';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

interface Props {
  report: FirmwareReportGroup;
}

const options: ApexOptions = {
  series: [
    {
      name: '',
      data: [],
    },
  ],
  chart: {
    toolbar: {
      show: true,
    },
    type: 'line',
    zoom: {
      enabled: true,
    },
  },
  legend: {
    show: true,
    showForSingleSeries: true,
    showForNullSeries: true,
    showForZeroSeries: true,
    position: 'bottom',
    horizontalAlign: 'center',
    floating: false,
    fontSize: '13px',
    fontFamily: 'Montserrat',
    fontWeight: 400,
    inverseOrder: false,
    height: 100,
    offsetX: 0,
    offsetY: 0,
    onItemClick: {
      toggleDataSeries: true,
    },
    onItemHover: {
      highlightDataSeries: true,
    },
  },
  xaxis: {
    type: 'category',
    categories: [],
    position: 'bottom',
    tickPlacement: 'on',
    axisBorder: {
      show: true,
    },
    labels: {
      show: true,
    },
  },
  yaxis: {
    show: true,
    showAlways: true,
    showForNullSeries: true,
    opposite: false,
    reversed: false,
    tickAmount: 6,
  },
  noData: {
    text: 'Loading...',
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: 0,
    style: {
      color: '#0080FFDD',
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
  },
  tooltip: {
    y: [
      {
        title: {
          formatter: function (val: string) {
            return val;
          },
        },
      },
    ],
  },
  grid: {
    borderColor: '#f1f1f1',
  },
};

const FirmwareReport: React.FC<Props> = ({ report }) => {
  const [firmChart, setFirmChart] = useState(options);
  const { byDateHour } = report;

  const data = Object.keys(byDateHour || []);
  const groupSize = Object.values(byDateHour || []).map((item) => item.groupSize);

  React.useEffect(() => {
    if (byDateHour) {
      setFirmChart({
        ...firmChart,
        series: [
          {
            name: 'Group Size',
            data: groupSize,
          },
        ],
        xaxis: {
          ...firmChart.xaxis,
          categories: data,
        },
      });
    } else {
      setFirmChart({
        ...firmChart,
        noData: {
          ...firmChart.noData,
          text: 'No Data',
          style: {
            color: '#0080FFDD',
            fontSize: '25px',
            fontFamily: 'Montserrat',
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [byDateHour]);

  return data.length ? (
    <>
      <Card title={`Group Size`} style={{ marginBottom: '1rem' }}>
        <div id="chart">
          <ReactApexChart options={firmChart} series={firmChart.series} type="line" height={450} />
        </div>
      </Card>
    </>
  ) : (
    <div style={{ display: 'grid', justifyContent: 'center', width: '100%', fontSize: '20px', color: '#0085fc' }}>
      <span>No Data to Display</span>
    </div>
  );
};

export default React.memo(FirmwareReport);
